// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YkyDabfXGMAwmg {
  display: flex;
  flex-flow: row wrap;
  min-height: 26px;
}
.z36bBwQzTFBmTY {
  align-items: center;
  height: 100%;
  min-height: 0;
  margin-top: 8px;
  margin-left: 4px;
  line-height: 0;
}
.z36bBwQzTFBmTY.Vvj2Sl57jPkbUH {
  margin-top: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reactionPiles": `YkyDabfXGMAwmg`,
	"empty": `z36bBwQzTFBmTY`,
	"cardBack": `Vvj2Sl57jPkbUH`
};
export default ___CSS_LOADER_EXPORT___;
